import { getExecEndpoint } from '../../service/getExecEndpoint';
import { BqResponse, EmptyObj } from '~/api/def/endpoints/types';
import { defaultServer } from '~/api/def/servers/defaultServer';

export const companyEndpoint = {
  server: defaultServer,
  path: 'company',
  description: 'Company endpoint',
};

export interface InviteUserEndpointDef {
  endpoint: typeof companyEndpoint;
  methods: {
    POST: {
      response: InviteUserResponsePOST;
      payload: InviteUserPayload;
    };
  };
}

const endpointCompanyExec =
  getExecEndpoint<InviteUserEndpointDef>(companyEndpoint);

export const endpointInviteUserPOST = async (payload: InviteUserPayload) =>
  endpointCompanyExec<'POST'>({
    method: 'POST',
    payload: payload,
    urlExtra: '/invite-user',
  });

type InviteUserResponsePOST = BqResponse<{ data: EmptyObj }>;

type InviteUserPayload = {
  emails: string[];
  role: string;
};
